import MapDisclaimer from './MapDisclaimer.component';

export default MapDisclaimer;
